/**
 * Entry point for the host application Security Portal
 *
 * This file uses the bootstrap pattern to load the app asynchronously.
 * This is required for Module Federation to properly initialize shared dependencies
 * before the application starts, ensuring that both host and remote apps can
 * share React, React-DOM, React Router, and other dependencies correctly.
 */

// Initialize Datadog RUM early for accurate page load tracking
import { initDatadogRum } from './config/datadog';
initDatadogRum();

// IMPORTANT: Save CLI params IMMEDIATELY before MSAL/React loads and redirects
// This must run synchronously before any async imports
(function preserveCliParams() {
  try {
    const urlParams = new URLSearchParams(window.location.search);
    const redirectUri = urlParams.get('redirect_uri');
    const state = urlParams.get('state');
    const client = urlParams.get('client');

    if (redirectUri && state) {
      console.log('[CLI Mode - Early] Saving params before MSAL redirect:', { redirectUri, state, client });
      sessionStorage.setItem('nvsec_cli_redirect_uri', redirectUri);
      sessionStorage.setItem('nvsec_cli_state', state);
      if (client) sessionStorage.setItem('nvsec_cli_client', client);
    }
  } catch (e) {
    console.error('[CLI Mode - Early] Failed to save params:', e);
  }
})();

// Dynamically import bootstrap to allow Module Federation to set up shared scope
import('./bootstrap').catch((err) => {
  console.error('Error loading bootstrap:', err);
});

// Empty export to make this a module (required by TypeScript)
export {};
